import React from 'react';

const Banner = ({ language = 'en' }) => {
  return (
    <div id="home">
      <img
        src={language === 'zh' ? '/assets/home/homechi.jpg' : '/assets/home/homeeng.jpg'}
        alt="Banner"
        style={{ width: '100%', display: 'block' }}
      />
    </div>
  );
};

export default Banner;
